import { safeDefine } from "../../registration/safe-define.js";
import { TimeElement } from "../../ui/time/element.js";
//#region src/define/ui/time.ts
safeDefine(TimeElement);
//#endregion
